import React from 'react';
import PropTypes from 'prop-types';
import AssessmentRow from '../AssessmentRow';
import { isRowSkipped, reformatItemLevelDetails } from '../../../../utils/shared/probeDetailUtils';
import './WordLetterProbeDetails.scss';
import { generateReactKey } from '../../../../utils/shared/commonUtils';
import { WORD_LET_PROB_DET } from '../../../../constants/reading/DemoModeConstants';

const WordLetterProbeDetails = props => {
    const {
        selfCorrectedMark,
        content: { lines },
        containerClassName,
        RowCell,
    } = props;
    const { skippedRows, selfCorrectedItems, incorrectItems, lastSelectedItem } =
        reformatItemLevelDetails(props.result.itemLevelDetails);

    return (
        <>
            <div
                data-tour-step={WORD_LET_PROB_DET}
                data-tour-allow-interaction
                className={`container wrf-container ${containerClassName}`}
            >
                {lines.map((line, lineIndex) => (
                    <AssessmentRow
                        key={generateReactKey(lineIndex)}
                        line={line}
                        lineIndex={lineIndex}
                        isRowSkipped={isRowSkipped(lineIndex, skippedRows)}
                        selfCorrectedItems={selfCorrectedItems}
                        incorrectItems={incorrectItems}
                        lastSelectedItem={lastSelectedItem}
                        selfCorrectedMark={selfCorrectedMark}
                        RowCell={RowCell}
                    />
                ))}
            </div>
        </>
    );
};

WordLetterProbeDetails.defaultProps = {
    selfCorrectedMark: 'sc',
    containerClassName: '',
};

WordLetterProbeDetails.propTypes = {
    content: PropTypes.object.isRequired,
    result: PropTypes.object.isRequired,
    selfCorrectedMark: PropTypes.string,
    containerClassName: PropTypes.string,
    RowCell: PropTypes.elementType.isRequired,
};

export default WordLetterProbeDetails;
